import React, { useState, useEffect } from "react";
import { ChromePicker } from "react-color";
import { Button, Popover } from "antd";
import Hamburger from "../assets/images/Product-icons/hamburger.png";
import Hotpot from "../assets/images/Product-icons/hot-pot.png";

const ColorPicker = ({ initialValue = "#a5b51e", onChange }) => {
  const [color, setColor] = useState(initialValue);
  const [popoverVisible, setPopoverVisible] = useState(false);

  // Update color state if initialValue changes (for edit mode)
  useEffect(() => {
    setColor(initialValue);
  }, [initialValue]);

  const handleColorChange = (color) => {
    setColor(color.hex);
  };

  const handleSelectColor = () => {
    setPopoverVisible(!popoverVisible);
  };

  const handlePopoverClose = () => {
    setPopoverVisible(false);
  };

  const handleColorPickerChange = (color) => {
    setColor(color.hex);
    onChange(color.hex); // Propagate color change to parent component
  };

  return (
    <>

      <Popover
        content={
          <ChromePicker
            color={color}
            onChangeComplete={handleColorChange}
            onChange={handleColorPickerChange}
            disableAlpha={true} // Optionally disable alpha for better performance
          />
        }
        title="Select Color"
        trigger="click"
        visible={popoverVisible}
        onVisibleChange={setPopoverVisible}
      >
       
        <Button onClick={handleSelectColor} className="" type="primary">
          Select Color
        </Button>
     
      </Popover>
    </>
  );
};

export default ColorPicker;
